import { Season } from '../types/season'
import { http } from '../services/http'
export const fetchSeasons = async (): Promise<Array<Season>> => {
  const response = await http.get<Array<Season>>('/v2/seasons')
  return response.data
}
